import { Action, createAction, createReducer, on, props } from '@ngrx/store';
import merge from 'lodash/merge';

export interface Mask {
  account?: string; // 账户
  customer?: string; // 客户名称
}

export const setMask = createAction('[Mask] Set Mask Info', props<Mask>());
export const mergeMask = createAction('[Mask] Merge Mask Info', props<Partial<Mask>>());
export const resetMask = createAction('[Mask] Reset Empty Mask');

export function maskReducer(pState: Mask | undefined, action: Action) {
  return createReducer(
    {},
    on(setMask, (state, mask) => mask),
    on(mergeMask, (state, mask) => merge({}, state, mask)),
    on(resetMask, state => null)
  )(pState, action);
}
